import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledShowBookmarksSidebarButton } from './show-bookmarks-sidebar-button.styles';

const ShowBookmarksSidebarButton = () => {
  const [state, dispatch] = useContext(Context);
  const handleClick = () => {
    dispatch({ type: 'TOGGLE_BOOKMARKS_SIDEBAR' });
  };

  return (
    <StyledShowBookmarksSidebarButton
      data-ignore-click-outside="bookmarks-sidebar"
      onClick={handleClick}
      isActive={state.isBookmarksSidebarOpened}
    >
      Закладки
    </StyledShowBookmarksSidebarButton>
  );
};

export default ShowBookmarksSidebarButton;
